let initialState = {
  launchedScreen: {
    0: false,
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
  },
};

const SocialWallPersistScreenSettings = (state = initialState, action) => {
  switch (action.type) {
    case "RESET_SOCIAL_WALL_PERSIST_SCREEN_SETTINGS":
      return {
        ...initialState,
      };

    case "UPDATE_LAUNCH_SCREEN_IN_PERSIST":
      return {
        ...state,
        launchedScreen: action?.payload,
      };
    default:
      return state;
  }
};

export default SocialWallPersistScreenSettings;
